<template>
  <div class>
    <Loading v-if="!fetchedData" loadingString="Notes" />
    <div
      v-else
      id="mainDiv"
      class="container roundedBorder secondary-bg primary-fg"
    >
      <h2>Notes</h2>

      <div class="col s12">
        <div class="row">
          <div v-if="notes.length > 0" class="input-field col s8 m9">
            <i class="material-icons prefix secondary-fg">search</i>
            <textarea
              id="icon_prefix2"
              class="materialize-textarea primary-fg textareaBorder"
              v-model="searchValue"
            ></textarea>
            <label for="icon_prefix2">Search</label>
          </div>
          <div class="col s4 m3" style="padding-top: 20px">
            <a
              v-on:click="createNewNote"
              class="waves-effect waves-light primary-bg primary-fg btn"
              style="width: 100%"
            >
              New note
              <i class="material-icons left">add</i>
            </a>
          </div>
        </div>

        <ul v-if="filteredNotes.length > 0" class="collection">
          <li
            v-on:click="displayNoteDetails(note.guid)"
            class="collection-item primary-bg"
            v-for="note in filteredNotes"
            :key="note.guid"
          >
            <div
              style="display:flex; flex-direction: row; align-items: center; overflow: hidden; white-space: nowrap"
            >
              <i
                v-if="note.isFavorite"
                class="material-icons secondary-fg"
                style="margin-right: 10px;"
                >star</i
              >
              <span v-if="note.noteContent != ''">{{ note.noteContent }}</span>
              <span v-else class="grey-text lighten-1"> Empty note </span>
            </div>
          </li>
        </ul>

        <h5 v-else-if="notes.length > 0">
          <span class="secondary-fg">{{ searchValue }}</span> was not found
        </h5>

        <h6 v-else class="secondary-fg">Empty</h6>
      </div>
    </div>

    <!-- Note Details Modal Structure -->
    <div id="noteDetails" class="modal bottom-sheet primary-bg primary-fg">
      <div class="modal-content">
        <div class="row s12">
          <h6 id="noteDetailsDate" class="secondary-fg col">Date</h6>
          <a
            v-on:click="toggleFavoriteStatus()"
            class="waves-effect waves-light btn right secondary-bg secondary-fg"
            style="margin-left:10px"
          >
            <i class="material-icons">
              {{ lastNoteFavoriteStatus ? "star" : "star_border" }}
            </i>
          </a>
          <a
            v-on:click="removeNoteClicked"
            class="waves-effect waves-light btn red lighten-2 right col"
          >
            Remove
          </a>
        </div>

        <div class="input-field noteContentDiv">
          <textarea
            v-on:keyup.esc="hideNoteDetails"
            spellcheck="false"
            id="noteDetailsTextArea"
            class="materialize-textarea indigo darken-3 primary-fg noBorder"
            style="padding: 20px"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer secondary-bg" style="position: fixed; bottom: 0">
        <a
          v-on:click="hideNoteDetails"
          class="waves-effect waves-light btn-flat secondary-fg"
          >Done</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import M from "materialize-css";
import Loading from "../components/Loading.vue";
import { SecretNoteObject, NOTES_API_ENDPOINT } from "../common.js";


export default {
  name: "Notes",
  components: {
    Loading
  },
  data: function() {
    return {
      notes: [],
      searchValue: "",
      lastNoteGuid: "",
      fetchedData: false
    };
  },
  computed: {
    filteredNotes: function() {
      let vueInstance = this;
      return this.notes.filter(function(note) {
        return note.noteContent
          .toLowerCase()
          .includes(vueInstance.searchValue.toLowerCase());
      });
    },
    lastNoteFavoriteStatus: function() {
      if (this.lastNoteGuid == "") return false;
      let index = this.notes.map(n => n.guid).indexOf(this.lastNoteGuid);
      return this.notes[index].isFavorite;
    }
  },
  methods: {
    sortNotes: function() {
        let favoriteNotes = this.notes.filter(note => note.isFavorite);
        let nonfavoriteNotes = this.notes.filter(note => !note.isFavorite);

        // sort by date
        favoriteNotes.sort(function(a, b) {
          return b.timeStamp - a.timeStamp;
        });
        nonfavoriteNotes.sort(function(a, b) {
          return b.timeStamp - a.timeStamp;
        });

        // combine all notes into single array
        this.notes = favoriteNotes.concat(nonfavoriteNotes);
    },
    getTimeStamp: function() {
      return new Date().getTime();
    },
    displayNoteDetails: function(noteGuid) {
      // Store guid for later usage (update / remove)
      this.lastNoteGuid = noteGuid;

      // Get the note object with the given guid
      let selectedNote = this.notes.find(p => p.guid == noteGuid);

      // Set the note content and last edit data
      document.getElementById("noteDetailsDate").innerHTML =
        selectedNote.lastEditedDate;
      document.getElementById("noteDetailsTextArea").value =
        selectedNote.noteContent;

      // Show the modal
      let noteDetailsModal = document.getElementById("noteDetails");
      M.Modal.getInstance(noteDetailsModal).open();

      // Resize the text area
      M.textareaAutoResize(document.getElementById("noteDetailsTextArea"));
    },
    removeNoteClicked: async function() {
      let idToken = await this.getIdToken();

      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken
        },
        body: JSON.stringify({
          note: {
            guid: this.lastNoteGuid
          }
        })
      };
      let serverResponse = await fetch(NOTES_API_ENDPOINT, options).then(
        res => {
          return res.json();
        }
      );
      if (!serverResponse.success) {
        alert(`Failed while deleting the note: ${serverResponse.data}`);
        return;
      }

      // Then remove from the local array
      this.notes = this.notes.filter(n => n.guid !== this.lastNoteGuid);

      // Dismiss the modal
      let noteDetailsModal = document.getElementById("noteDetails");
      M.Modal.getInstance(noteDetailsModal).close();

      this.lastNoteGuid = "";
    },
    generateTimeString: function() {
      let dateString = new Date().toLocaleDateString(["ban", "id"]);
      let time = new Date().toLocaleTimeString(["ban", "id"]);
      dateString = dateString + " - " + time;

      return dateString;
    },
    updateLastSelectedNote: async function(forceUpdate = false) {
      // Check if the note is updated
      let lastNoteContent = document.getElementById("noteDetailsTextArea")
        .value;
      let lastNoteObject = this.notes.find(p => p.guid == this.lastNoteGuid);

      if (forceUpdate || lastNoteContent != lastNoteObject.noteContent) {
        // Note content is updated
        let lastEditedDate = this.generateTimeString();
        let timeStamp = this.getTimeStamp();

        let cseEnabled = await this.isCSEEnabled();
        // Update the database
        let idToken = await this.getIdToken();
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken
          },
          body: JSON.stringify({
            note: {
              noteContent: cseEnabled ? this.encrypt(lastNoteContent) : lastNoteContent,
              guid: this.lastNoteGuid,
              lastEditedDate: cseEnabled ? this.encrypt(lastEditedDate) : lastEditedDate,
              timeStamp: cseEnabled ? this.encrypt(timeStamp) : timeStamp,
              isFavorite: cseEnabled ? this.encrypt(lastNoteObject.isFavorite) : lastNoteObject.isFavorite
            }
          })
        };
        let serverResponse = await fetch(NOTES_API_ENDPOINT, options).then(
          res => {
            return res.json();
          }
        );
        if (serverResponse.success) {
          let index = this.notes
            .map(note => note.guid)
            .indexOf(this.lastNoteGuid);

          this.notes[index].noteContent = lastNoteContent;
          this.notes[index].lastEditedDate = lastEditedDate;
          this.notes[index].timeStamp = timeStamp;
        } else {
          alert(`Failed while saving the note: ${serverResponse.data}`);
          return;
        }

        // Re-order the notes
        this.sortNotes();
      }
    },
    hideNoteDetails: async function() {
      await this.updateLastSelectedNote();
      this.lastNoteGuid = "";
      let noteDetailsModal = document.getElementById("noteDetails");
      M.Modal.getInstance(noteDetailsModal).close();
    },
    guid: function() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    createNewNote: async function() {
      let noteGuid = this.guid();
      let lastEditedDate = this.generateTimeString();
      let idToken = await this.getIdToken();
      let newNoteObject = new SecretNoteObject(
        "",
        lastEditedDate,
        noteGuid,
        this.getTimeStamp(),
        false
      );

      let cseEnabled = await this.isCSEEnabled();
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken
        },
        body: JSON.stringify({
          note: {
            noteContent: cseEnabled ? this.encrypt(newNoteObject.noteContent) : newNoteObject.noteContent,
            lastEditedDate: cseEnabled ? this.encrypt(newNoteObject.lastEditedDate) : newNoteObject.lastEditedDate,
            guid: newNoteObject.guid,
            timeStamp: cseEnabled ? this.encrypt(newNoteObject.timeStamp) : newNoteObject.timeStamp,
            isFavorite: cseEnabled ? this.encrypt(false) : false 
          }
        })
      };
      let serverResponse = await fetch(NOTES_API_ENDPOINT, options).then(
        res => {
          return res.json();
        }
      );
      if (!serverResponse.success) {
        alert(`Failed while creating the note: ${serverResponse.data}`);
        return;
      }

      this.notes = [...[newNoteObject], ...this.notes];
      this.displayNoteDetails(noteGuid);
    },
    toggleFavoriteStatus: async function() {
      // Update the local array
      let index = this.notes.map(n => n.guid).indexOf(this.lastNoteGuid);
      this.notes[index].isFavorite = !this.notes[index].isFavorite;
      await this.updateLastSelectedNote(true);
    }
  },
  mounted: async function() {
    // If there is no user navigate to the root page
    if (!firebase.auth().currentUser) {
      this.$router.push("/");
      return;
    }

    // Enable tab on text area
    let textareas = document.getElementsByTagName("textarea");
    textareas.forEach(textare => {
      textare.onkeydown = function(e) {
        if (e.keyCode == 9 || e.which == 9) {
          e.preventDefault();
          const TAB_SIZE = 4;
          // The one-liner that does the magic
          document.execCommand("insertText", false, " ".repeat(TAB_SIZE));
        }
      };
    });

    // Initialize the materialize components
    // This also closes the navbar if open
    M.AutoInit();

    let elems = document.querySelectorAll(".modal");
    M.Modal.init(elems, {
      dismissible: true
    });

    this.notes = await this.fetchNotes();
    this.fetchedData = true;

    let vueInstance = this;
    window.addEventListener(
      "beforeunload",
      function() {
        // Check if there is an unsaved note, if so save it
        if (vueInstance.lastNoteGuid != "") {
          // This function also checks if the note content has changed
          vueInstance.hideNoteDetails();
        }
      },
      false
    );
  },
  metaInfo: {
    title: "Notes",
    meta: [
      { name: "description", content: "Store encypted notes with LockerApp." },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {
        name: "keywords",
        content:
          "LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application"
      }
    ]
  }
};
</script>

<style scoped>
#mainDiv {
  padding: 20px;
}
#noteDetails {
  min-height: 100% !important;
}
.noteContent {
  border-color: red !important;
}

.noBorder {
  border: 0px !important;
  box-shadow: 0 0 0 0 var(--primary-fg-color) !important;
}

.noBorder:active {
  border: 0px !important;
  box-shadow: 0 0 0 0 var(--primary-fg-color) !important;
}
</style>
